import { benefitSummarySection } from './benefit-summary-section'
import { benefitSummarySectionBumnanSmart } from './benefit-summary-section-bumnan-smart'
import { policyValueTableSection } from './policy-value-table-section'
import { policyValueTableSectionBumnanSmart } from './policy-value-table-section-bumnan-smart'
import { taxDeductionBenefit } from './tax-deduction-section'
import { legalDisclaimerSection } from './legal-disclaimer-section'
import { profileSnapshotSection } from './profile-snapshot-section'
import { productBenefitsSection } from './product-benefit-section'
import { basicPlanConditionSection } from './basicplan-condition-section'

export const section = {
  policyValueTable: policyValueTableSection,
  policyValueTableBumnanSmart: policyValueTableSectionBumnanSmart,
  benefitSummary: benefitSummarySection,
  benefitSummaryBumnanSmart: benefitSummarySectionBumnanSmart,
  taxDeductionBenefit: taxDeductionBenefit,
  legalDisclaimer: legalDisclaimerSection,
  profileSnapshot: profileSnapshotSection,
  productBenefits: productBenefitsSection,
  basicPlanCondition: basicPlanConditionSection,
}
